import { ReactComponent as ArrowRightIcon } from "./assets/icons/arrowRight.svg";
import TopReferralCard from "./common/TopReferralCard";
import ReferralPosListItem from "./common/ReferralPosListItem";
import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { navigateParametersArray, gridItems as mockGridItems } from "./global/constants";
import Lottie from "react-lottie";
import * as animatedGiftboxData from "./assets/animatedGiftbox.json";
import { AppContext } from "./global/context";
import { ReactComponent as PlusIcon } from "./assets/icons/plus.svg";
import MainPageBanner from "./MainPageBanner";
import Rechart from "./Rechart";
import { fetchTrends } from "./global/api";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animatedGiftboxData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export default function Main() {
  const navigate = useNavigate();
  const appState = useContext(AppContext);
  const [gridItems, setGridItems] = useState(/** @type {typeof mockGridItems} */ ([]));
  const [referrals, setReferrals] = useState(/** @type {import("./context").ListItem[]} */ ([]));
  const [trends, setTrends] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const data = await fetchTrends();
        setTrends(data);
      } catch (error) {
        console.error(error);
        alert("An error occured!");
      }
    })();
  }, []);

  useEffect(() => {
    if (appState) {
      mockGridItems[0].count = appState.uniqueReferrals;
      mockGridItems[1].count = appState.totalReferrals;
      setGridItems(mockGridItems);
      setReferrals(appState.topFiveList);
    }
  }, [appState]);

  const onViewAllClick = useCallback(() => {
    navigate(...navigateParametersArray.leaderBoard);
  }, [navigate]);

  return (
    <div id="main-page">
      <MainPageBanner />
      <div id="main-page-content">
        <div id="main-page-content-pull-up"></div>
        <div id="main-page-elem-1">
          <h4 id="main-page-elem-1-heading">Numbers so far...</h4>
          <div id="main-page-elem-1-grid">
            {gridItems.map((item) => (
              <div key={item.text} style={{ background: item.background }}>
                <div className="main-page-elem-1-grid-item-elem-1">
                  <span>{item.text}</span>
                  <img src={item.icon} alt="" />
                </div>
                <span className="main-page-elem-1-grid-item-elem-2">{item.count}</span>
              </div>
            ))}
          </div>
        </div>
        <div id="main-page-elem-2">
          <Lottie options={defaultOptions} style={{ width: "88px", height: "88px", margin: "0px" }} />
          <div id="main-page-elem-2-elem-2">
            <span id="main-page-elem-2-elem-2-text-1">ReSOPs are waiting for you!</span>
            <a
              id="main-page-elem-2-elem-2-text-2-cont"
              href="https://classplusapp.com/referral/create"
              target="_blank"
              rel="noreferrer"
            >
              <span id="main-page-elem-2-elem-2-text-2">Create your Referral Link</span>
              <ArrowRightIcon />
            </a>
          </div>
        </div>
        <div id="main-page-elem-3">
          <div id="main-page-elem-3-elem-1">
            <h4 id="main-page-elem-3-heading">Top Referral Generators</h4>
            <button className="btn2" onClick={onViewAllClick}>
              View All
            </button>
          </div>
          <div id="main-page-elem-3-elem-2">
            {referrals.slice(0, 3).map((item, i) => (
              <TopReferralCard
                key={item.uuid}
                img={item.imageURL}
                name={item.name}
                count={item.referrals}
                position={i + 1}
              />
            ))}
          </div>
          <div id="main-page-elem-3-elem-3">
            {referrals.slice(3, 5).map((item, i) => (
              <ReferralPosListItem
                key={item.uuid}
                img={item.imageURL}
                name={item.name}
                count={item.referrals}
                position={i + 4}
              />
            ))}
          </div>
        </div>
        <div id="main-page-elem-4">
          <h4 id="main-page-elem-4-heading">Referral Trend Line</h4>
          <Rechart trends={trends} />
        </div>
      </div>
      <a id="main-page-floating-btn" href="https://classplusapp.com/referral/create" target="_blank" rel="noreferrer">
        <PlusIcon />
        <span>Give a referral</span>
      </a>
    </div>
  );
}
